import { FILTER_NAMES } from '../../../../components/filters/hooks/filter-names.constants';
export const FILTERS_ADDITIONAL = [
  FILTER_NAMES.BRAND,
  FILTER_NAMES.SUBBRAND,
  FILTER_NAMES.SIZEGROUP,
  FILTER_NAMES.PPG,
];

export const FILTERS = [
  FILTER_NAMES.METACATEGORY,
  FILTER_NAMES.MARKET,
  FILTER_NAMES.CATEGORY,
  FILTER_NAMES.SCENARIOPLANNERWEEKSFROM,
  FILTER_NAMES.SCENARIOPLANNERNUMBEROFWEEKS,
  FILTER_NAMES.SCENARIOPLANNERCOEFFVERSION,
];
/**
 * Filters required to load default selection.
 */
export const FILTERS_WITH_DEFAULT_VAL = [
  FILTER_NAMES.SCENARIOPLANNERWEEKSFROM,
  FILTER_NAMES.SCENARIOPLANNERNUMBEROFWEEKS,
];
/**
 * Enhanced interface to support both create and edit modes
 */
export interface ScenarioPlannerNewModalComponentProps {
  show: boolean;
  onClose?(show: boolean): void;
}

export interface ScenarioPlannerEditModalComponentProps
  extends ScenarioPlannerNewModalComponentProps {
  scenarioToEditId: string;
}
